import React from 'react';
import { connect } from 'react-redux';
import { USER_ROLES, isUserAuthorized } from 'utils';
import './home.scss';

const mapStateToProps = (state: any) => ({
  isAuthenticated: !!state.auth.loggedInUser,
  userRoles: state.auth.loggedInUser ? state.auth.loggedInUser.get('roles') : [],
});

const Home =(props)=>{
  const isUserAdmin = isUserAuthorized(props.userRoles, [USER_ROLES.ADMIN]);
  const isUserSalesChannelUser = isUserAuthorized(props.userRoles, [USER_ROLES.SALES_PERSON]);
  
  /* We are not putting isUserSalesChannelUser in 1st if 
  because in that case first if will always be true for admin user as admin will 
  always be sales channel user */
  if (isUserAdmin) {
    props.history.push('/orders');
  } else if (isUserSalesChannelUser) {
    props.history.push('/sales-channels');
  } else{
    props.history.push('/orders');
  }
  return (
    <div className="home">
        Home
    </div>
  );
};

const HomeWrapper = connect(mapStateToProps, null)(Home);
export { HomeWrapper as Home };
